// import { useSelector } from 'react-redux';

// const authentication = useSelector((state) => state.auth.authentication);
// const permissions = authentication.permissions

export function hasPermission(roles) {
    const role = JSON.parse(localStorage.getItem('authentication')).role
    return roles.includes(role)
}
